import React, { useMemo } from 'react';
import { ModuleType, useCategoryList, useInfiniteScroll, useUpcomingLive } from '@vodafoneis/sjonvarpskjarni-js-lib';
import CategoryCarousel from './CategoryCarousel';
import MediaCarousel from './MediaCarousel';
import useContentGridRenderer from '../hooks/useContentGridRenderer';
import { CATEGORY_LIMIT, CONTENT_LIMIT } from '../config/constants';
import { MediaComponentType } from '../models/MediaComponentType';
import MainTitle from './MainTitle';

const { EVENT } = MediaComponentType;
const { M2 } = ModuleType;

type SportWorldSceneProps = {
	title: string;
	color: string;
	channelIds: string[];
	filter?: string[];
	categoryId: number;
};

const SportWorldEventCarousel: React.FC<SportWorldSceneProps> = ({ channelIds, filter }) => {
	const { events, fetchMoreEvents } = useUpcomingLive({
		limit: CONTENT_LIMIT,
		channelIds,
		filter,
	});

	const renderItem = useContentGridRenderer({ moduleType: M2, mediaComponentType: EVENT });

	if (!events) return null;

	return <MediaCarousel id={`sport-world-events-${channelIds.join('-')}`} title={'Framundan í beinni'} items={events} renderItem={renderItem} fetchMoreItems={fetchMoreEvents} />;
};

// @ts-ignore
const SportWorldCategoryCarousel: React.FC<SportWorldSceneProps> = ({ categoryId }) => {
	const { category, fetchMoreCategories } = useCategoryList(categoryId, CATEGORY_LIMIT, CONTENT_LIMIT);

	useInfiniteScroll(fetchMoreCategories);

	return useMemo(() => {
		if (!category?.categories) return null;

		return category.categories.map((subCategory) => <CategoryCarousel key={subCategory.id} id={`carousel-${category.id}-${subCategory.id}`} category={subCategory} />);
	}, [category]);
};

export const SportWorld: React.FC<SportWorldSceneProps> = (props) => {
	const { title, color } = props;

	return (
		<>
			<MainTitle title={title} color={color} />
			<SportWorldEventCarousel {...props} />
			<SportWorldCategoryCarousel {...props} />
		</>
	);
};
